import { Point, PointNode } from "tm-shared/types";
import { arrayToRecord } from "tm-shared/utils";

export const buildPointChains = (points: Point[]): PointNode[] => {
    const pointMap: Record<string, PointNode> = arrayToRecord(
        points.map((point) => ({ ...point })),
        "id",
    );

    const childIds = new Set<string>();

    for (const point of points) {
        const parentId = point.market.parentInfo!.parentId;

        if (!parentId) continue;

        const parent = pointMap[parentId];
        const current = pointMap[point.id];

        if (parent && current) {
            parent.child = current;
            childIds.add(current.id);
        }
    }

    return Object.values(pointMap).filter((point) => !childIds.has(point.id));
};
